module.exports = __webpack_public_path__ + "static/media/ic_full_screen_expand.2c5ce97d.svg";